export const translations = {
  fr: {
    tagline: "60 secondes pour devenir une légende.",
    subtagline: "Chaque choix compte. Chaque destin est partageable.",
    play: "JOUER",
    leaderboard: "Classement",
    howToPlay: "Comment ça marche ?",
    pseudoLabel: "Ton pseudo",
    pseudoPlaceholder: "Entre ton pseudo…",
    pseudoRequired: "Choisis un pseudo pour jouer (2 à 20 caractères).",
    chooseDestiny: "Choisis ton destin",
    chooseDestinySub: "Un domaine. 60 secondes. Une légende à écrire.",
    back: "Retour",
    replay: "Rejouer",
    replayBonus: "Rejouer avec bonus (pub)",
    share: "Partager mon destin",
    download: "Télécharger la carte",
    shareCopied: "Score copié ! Colle-le sur TikTok ou Instagram.",
    yourDestiny: "Ton destin",
    finalScore: "Score final",
    points: "POINTS",
    worldRank: "Rang mondial",
    betterThan: "Meilleur que {n}% des joueurs",
    timer: "Temps",
    argent: "Argent",
    gloire: "Gloire",
    energie: "Énergie",
    chance: "Chance",
    close: "Fermer",
    allDomains: "Tous",
    global: "Mondial",
    noScores: "Aucun score pour l'instant. Sois le premier !",
    rankCol: "Rang",
    playerCol: "Joueur",
    scoreCol: "Score",
    loading: "Chargement…",
    computingDestiny: "Calcul de ton destin…",
    riskSuccess: "✨ Réussi !",
    riskFail: "💥 Échec ! La chance n'était pas avec toi.",
    endTime: "⏱️ Temps écoulé !",
    endEnergy: "😵 Épuisé ! Plus d'énergie.",
    endFinish: "🏁 Parcours terminé !",
    adLabel: "Publicité",
    adSponsored: "Contenu sponsorisé",
    adSkipIn: "Passer dans {n}s",
    adSkip: "Passer la pub",
    rewardedTitle: "Vidéo récompensée",
    rewardedDesc: "Regarde cette courte pub pour rejouer avec un bonus de chance !",
    rewardedGet: "Obtenir mon bonus",
    bonusGranted: "Bonus de chance activé pour ta prochaine partie !",
    shareText: "J'ai fait {score} points sur Destin Express et j'ai fini {rank} ! Bats-moi 👉 #DestinExpress",
    shareChallenge: "J'ai fini {rank} avec {score} pts sur Destin Express 🔥 Arrives-tu à me battre ?",
    challengeBanner: "🔥 {pseudo} te défie : {score} pts. Bats son score !",
    challengeBeaten: "🎉 Défi relevé ! Tu bats {pseudo} de {n} pts !",
    challengeMissed: "Presque ! Il te manquait {n} pts pour battre {pseudo}.",
    live: "Mode Live",
    liveHostTitle: "Le public décide",
    liveHostDesc: "Ton audience vote en direct sur chaque choix. Parfait pour Twitch, YouTube & TikTok Live.",
    liveChooseDomain: "Choisis ton domaine",
    liveCreateRoom: "Créer le live",
    liveShareTitle: "Fais voter ton public en direct",
    liveScanQr: "Scanne le QR code ou va sur",
    liveRoomCode: "Code du live",
    liveViewers: "spectateurs",
    liveStart: "Démarrer le live",
    liveWaitViewers: "En attente de spectateurs…",
    liveQuestion: "Question",
    liveVoteInProgress: "Vote en cours",
    liveMajorityChose: "Le public a choisi",
    liveWaitingHost: "En attente du streamer…",
    liveVoteNow: "Vote maintenant !",
    liveVoted: "Vote enregistré ✓ — attends le résultat",
    liveJoinTitle: "Rejoins le live",
    liveEnterCode: "Entre le code du live",
    liveJoin: "Rejoindre",
    liveRoomNotFound: "Live introuvable, vérifie le code",
    liveHostLeft: "Le streamer a quitté le live",
    liveFinished: "Live terminé !",
    liveCollectiveDestiny: "Destin décidé par le public",
    liveConnecting: "Connexion…",
    statsLives: "{n} lives en cours",
    statsChallenges: "{n} défis relevés aujourd'hui",
    liveBeatDestiny: "Bats le destin choisi par {n} personnes !",
    liveShareChallengeText: "{n} personnes ont décidé ce destin en live sur Destin Express 🔥 Arrives-tu à les battre ?",
    liveConvertHint: "Balance ce lien en fin de stream pour défier tes spectateurs 👇",
    liveCopyLink: "Copier le lien de défi",
    liveLinkCopied: "Lien copié ✓",
    liveVotersDecided: "{n} personnes ont décidé ce destin",
    liveObs: "Mode OBS",
    liveReactions: "Réactions",
    rareEpic: "⚡ Épique",
    rareLegendary: "🌟 Légendaire",
    howToSteps: [
      { t: "1. Choisis ton domaine", d: "Streamer, footballeur, rappeur, gamer ou YouTubeur." },
      { t: "2. Prends des décisions", d: "10 choix rapides. Tes stats bougent à chaque décision." },
      { t: "3. Gère tes 60 secondes", d: "Le chrono tourne. Si ton énergie tombe à 0, c'est fini." },
      { t: "4. Découvre ton titre", d: "Anonyme, Connu, Star ou Légende selon ton score." },
      { t: "5. Partage et défie", d: "Génère ta carte, partage-la et bats le classement mondial." },
    ],
    ranks: { legende: "LÉGENDE", star: "STAR", connu: "CONNU", anonyme: "ANONYME" },
    rankTitles: { legende: "« Le Phénomène »", star: "« La Révélation »", connu: "« Le Connu »", anonyme: "« L'Oublié »" },
    punchlines: {
      legende: "J'ai fini LÉGENDE en 60 secondes. À toi de faire mieux.",
      star: "Star en une minute. Pas mal, non ?",
      connu: "J'ai fini connu. Bats mon score si tu peux.",
      anonyme: "Le destin m'a oublié. Aide-moi à me venger.",
    },
    consentTitle: "Confidentialité & publicité",
    consentText: "On utilise des cookies publicitaires (Google AdSense) pour financer le jeu gratuitement. Tu peux accepter ou refuser les pubs personnalisées.",
    consentAccept: "Accepter",
    consentRefuse: "Refuser",
    stepPick: "Choisis",
    stepDecide: "Décide",
    stepShare: "Partage",
    store: "Boutique",
    storeSub: "Personnalise ta carte de destin",
    loginGoogle: "Se connecter avec Google",
    owned: "Possédé",
    buy: "Acheter",
    loginToBuy: "Connecte-toi pour acheter et sauvegarder tes skins",
    logout: "Déconnexion",
    cardSkin: "Skin de carte",
    defaultSkin: "Défaut",
    paymentSuccess: "Achat réussi ! Skin débloqué 🎉",
    paymentPending: "Validation du paiement…",
    paymentCancel: "Paiement annulé.",
    contact: "Contact",
    footerLegal: "Confidentialité",
    footerNotice: "Mentions légales",
    footerTerms: "CGU / CGV",
    installTitle: "Installe Destin Express",
    installDesc: "Ajoute le jeu à ton écran d'accueil pour y jouer en un tap.",
    installBtn: "Installer",
    installIos: "Sur iPhone : appuie sur Partager puis « Sur l'écran d'accueil »",
    installLater: "Plus tard",
    badgeFree: "100 % gratuit",
    badgeNoSignup: "Sans inscription",
    badgePrivacy: "Données protégées",
    badgeLangs: "3 langues",
    aboutTitle: "C'est quoi Destin Express ?",
    aboutBody:
      "Destin Express est un jeu de simulation gratuit et sans inscription. En 60 secondes, tu choisis une carrière et tu prends des décisions qui façonnent ton destin, puis tu obtiens ta carte de score à partager. Aucun téléchargement obligatoire et aucune donnée personnelle revendue : nous respectons le RGPD. Le jeu se joue directement dans ton navigateur, sur mobile comme sur ordinateur.",
    publishedBy: "Édité par",
    blog: "Blog",
    blogTitle: "Le Blog",
    blogSubtitle: "Astuces de jeu, coulisses du développement et guides pour maîtriser Destin Express.",
    blogRead: "min de lecture",
    blogReadMore: "Lire",
    blogNotFound: "Article introuvable.",
    blogCtaTitle: "Prêt à tenter ta chance ?",
    blogCtaButton: "Jouer maintenant",
    langName: "Français",
  },
  en: {
    tagline: "60 seconds to become a legend.",
    subtagline: "Every choice counts. Every destiny is shareable.",
    play: "PLAY",
    leaderboard: "Leaderboard",
    howToPlay: "How to play?",
    pseudoLabel: "Your nickname",
    pseudoPlaceholder: "Enter your nickname…",
    pseudoRequired: "Pick a nickname to play (2 to 20 characters).",
    chooseDestiny: "Choose your destiny",
    chooseDestinySub: "One field. 60 seconds. A legend to write.",
    back: "Back",
    replay: "Replay",
    replayBonus: "Replay with bonus (ad)",
    share: "Share my destiny",
    download: "Download card",
    shareCopied: "Score copied! Paste it on TikTok or Instagram.",
    yourDestiny: "Your destiny",
    finalScore: "Final score",
    points: "POINTS",
    worldRank: "World rank",
    betterThan: "Better than {n}% of players",
    timer: "Time",
    argent: "Money",
    gloire: "Fame",
    energie: "Energy",
    chance: "Luck",
    close: "Close",
    allDomains: "All",
    global: "Global",
    noScores: "No scores yet. Be the first!",
    rankCol: "Rank",
    playerCol: "Player",
    scoreCol: "Score",
    loading: "Loading…",
    computingDestiny: "Computing your destiny…",
    riskSuccess: "✨ Success!",
    riskFail: "💥 Failed! Luck wasn't on your side.",
    endTime: "⏱️ Time's up!",
    endEnergy: "😵 Burnt out! No energy left.",
    endFinish: "🏁 Journey complete!",
    adLabel: "Advertisement",
    adSponsored: "Sponsored content",
    adSkipIn: "Skip in {n}s",
    adSkip: "Skip ad",
    rewardedTitle: "Rewarded video",
    rewardedDesc: "Watch this short ad to replay with a luck bonus!",
    rewardedGet: "Get my bonus",
    bonusGranted: "Luck bonus activated for your next game!",
    shareText: "I scored {score} points on Destin Express and finished {rank}! Beat me 👉 #DestinExpress",
    shareChallenge: "I finished {rank} with {score} pts on Destin Express 🔥 Can you beat me?",
    challengeBanner: "🔥 {pseudo} challenges you: {score} pts. Beat their score!",
    challengeBeaten: "🎉 Challenge crushed! You beat {pseudo} by {n} pts!",
    challengeMissed: "So close! You needed {n} more pts to beat {pseudo}.",
    live: "Live Mode",
    liveHostTitle: "The crowd decides",
    liveHostDesc: "Your audience votes live on every choice. Perfect for Twitch, YouTube & TikTok Live.",
    liveChooseDomain: "Choose your field",
    liveCreateRoom: "Create the live",
    liveShareTitle: "Let your audience vote live",
    liveScanQr: "Scan the QR code or go to",
    liveRoomCode: "Live code",
    liveViewers: "viewers",
    liveStart: "Start the live",
    liveWaitViewers: "Waiting for viewers…",
    liveQuestion: "Question",
    liveVoteInProgress: "Voting in progress",
    liveMajorityChose: "The crowd chose",
    liveWaitingHost: "Waiting for the streamer…",
    liveVoteNow: "Vote now!",
    liveVoted: "Vote saved ✓ — wait for the result",
    liveJoinTitle: "Join the live",
    liveEnterCode: "Enter the live code",
    liveJoin: "Join",
    liveRoomNotFound: "Live not found, check the code",
    liveHostLeft: "The streamer left the live",
    liveFinished: "Live over!",
    liveCollectiveDestiny: "Destiny decided by the crowd",
    liveConnecting: "Connecting…",
    statsLives: "{n} lives running now",
    statsChallenges: "{n} challenges taken today",
    liveBeatDestiny: "Beat the destiny chosen by {n} people!",
    liveShareChallengeText: "{n} people decided this destiny live on Destin Express 🔥 Can you beat them?",
    liveConvertHint: "Drop this link at the end of your stream to challenge your viewers 👇",
    liveCopyLink: "Copy the challenge link",
    liveLinkCopied: "Link copied ✓",
    liveVotersDecided: "{n} people decided this destiny",
    liveObs: "OBS Mode",
    liveReactions: "Reactions",
    rareEpic: "⚡ Epic",
    rareLegendary: "🌟 Legendary",
    howToSteps: [
      { t: "1. Choose your field", d: "Streamer, footballer, rapper, gamer or YouTuber." },
      { t: "2. Make decisions", d: "10 rapid choices. Your stats shift with each one." },
      { t: "3. Manage your 60 seconds", d: "The clock ticks. If your energy hits 0, it's over." },
      { t: "4. Discover your title", d: "Nobody, Known, Star or Legend based on your score." },
      { t: "5. Share and challenge", d: "Generate your card, share it and top the global board." },
    ],
    ranks: { legende: "LEGEND", star: "STAR", connu: "KNOWN", anonyme: "NOBODY" },
    rankTitles: { legende: "\"The Phenomenon\"", star: "\"The Breakout\"", connu: "\"The Known\"", anonyme: "\"The Forgotten\"" },
    punchlines: {
      legende: "I finished a LEGEND in 60 seconds. Now do better.",
      star: "A star in one minute. Not bad, huh?",
      connu: "I finished known. Beat my score if you can.",
      anonyme: "Destiny forgot me. Help me get revenge.",
    },
    consentTitle: "Privacy & advertising",
    consentText: "We use advertising cookies (Google AdSense) to keep the game free. You can accept or decline personalized ads.",
    consentAccept: "Accept",
    consentRefuse: "Decline",
    stepPick: "Pick",
    stepDecide: "Decide",
    stepShare: "Share",
    store: "Store",
    storeSub: "Customize your destiny card",
    loginGoogle: "Sign in with Google",
    owned: "Owned",
    buy: "Buy",
    loginToBuy: "Sign in to buy and save your skins",
    logout: "Log out",
    cardSkin: "Card skin",
    defaultSkin: "Default",
    paymentSuccess: "Purchase complete! Skin unlocked 🎉",
    paymentPending: "Confirming payment…",
    paymentCancel: "Payment cancelled.",
    contact: "Contact",
    footerLegal: "Privacy",
    footerNotice: "Legal Notice",
    footerTerms: "Terms",
    installTitle: "Install Destin Express",
    installDesc: "Add the game to your home screen to play in one tap.",
    installBtn: "Install",
    installIos: "On iPhone: tap Share then \"Add to Home Screen\"",
    installLater: "Later",
    badgeFree: "100% free",
    badgeNoSignup: "No sign-up",
    badgePrivacy: "Privacy-friendly",
    badgeLangs: "3 languages",
    aboutTitle: "What is Destin Express?",
    aboutBody:
      "Destin Express is a free, no-sign-up simulation game. In 60 seconds you pick a career and make decisions that shape your destiny, then get a shareable score card. No mandatory download and no personal data sold — we're GDPR-compliant. The game runs right in your browser, on mobile and desktop.",
    publishedBy: "Published by",
    blog: "Blog",
    blogTitle: "The Blog",
    blogSubtitle: "Game tips, behind-the-scenes and guides to master Destin Express.",
    blogRead: "min read",
    blogReadMore: "Read",
    blogNotFound: "Article not found.",
    blogCtaTitle: "Ready to try your luck?",
    blogCtaButton: "Play now",
    langName: "English",
  },
  es: {
    tagline: "60 segundos para volverte una leyenda.",
    subtagline: "Cada decisión cuenta. Cada destino se comparte.",
    play: "JUGAR",
    leaderboard: "Clasificación",
    howToPlay: "¿Cómo se juega?",
    pseudoLabel: "Tu apodo",
    pseudoPlaceholder: "Escribe tu apodo…",
    pseudoRequired: "Elige un apodo para jugar (2 a 20 caracteres).",
    chooseDestiny: "Elige tu destino",
    chooseDestinySub: "Un campo. 60 segundos. Una leyenda por escribir.",
    back: "Volver",
    replay: "Jugar de nuevo",
    replayBonus: "Repetir con bonus (anuncio)",
    share: "Compartir mi destino",
    download: "Descargar tarjeta",
    shareCopied: "¡Puntuación copiada! Pégala en TikTok o Instagram.",
    yourDestiny: "Tu destino",
    finalScore: "Puntuación final",
    points: "PUNTOS",
    worldRank: "Rango mundial",
    betterThan: "Mejor que el {n}% de los jugadores",
    timer: "Tiempo",
    argent: "Dinero",
    gloire: "Fama",
    energie: "Energía",
    chance: "Suerte",
    close: "Cerrar",
    allDomains: "Todos",
    global: "Global",
    noScores: "Aún no hay puntuaciones. ¡Sé el primero!",
    rankCol: "Rango",
    playerCol: "Jugador",
    scoreCol: "Puntos",
    loading: "Cargando…",
    computingDestiny: "Calculando tu destino…",
    riskSuccess: "✨ ¡Éxito!",
    riskFail: "💥 ¡Fallo! La suerte no estuvo contigo.",
    endTime: "⏱️ ¡Se acabó el tiempo!",
    endEnergy: "😵 ¡Agotado! Sin energía.",
    endFinish: "🏁 ¡Recorrido completado!",
    adLabel: "Publicidad",
    adSponsored: "Contenido patrocinado",
    adSkipIn: "Saltar en {n}s",
    adSkip: "Saltar anuncio",
    rewardedTitle: "Vídeo recompensado",
    rewardedDesc: "¡Mira este breve anuncio para repetir con un bonus de suerte!",
    rewardedGet: "Obtener mi bonus",
    bonusGranted: "¡Bonus de suerte activado para tu próxima partida!",
    shareText: "¡Hice {score} puntos en Destin Express y terminé como {rank}! Supérame 👉 #DestinExpress",
    shareChallenge: "Terminé como {rank} con {score} pts en Destin Express 🔥 ¿Puedes superarme?",
    challengeBanner: "🔥 {pseudo} te reta: {score} pts. ¡Supera su puntuación!",
    challengeBeaten: "🎉 ¡Reto superado! ¡Superas a {pseudo} por {n} pts!",
    challengeMissed: "¡Casi! Te faltaban {n} pts para superar a {pseudo}.",
    live: "Modo Live",
    liveHostTitle: "El público decide",
    liveHostDesc: "Tu audiencia vota en directo cada decisión. Ideal para Twitch, YouTube y TikTok Live.",
    liveChooseDomain: "Elige tu ámbito",
    liveCreateRoom: "Crear el directo",
    liveShareTitle: "Haz votar a tu público en directo",
    liveScanQr: "Escanea el QR o entra en",
    liveRoomCode: "Código del directo",
    liveViewers: "espectadores",
    liveStart: "Empezar el directo",
    liveWaitViewers: "Esperando espectadores…",
    liveQuestion: "Pregunta",
    liveVoteInProgress: "Votación en curso",
    liveMajorityChose: "El público eligió",
    liveWaitingHost: "Esperando al streamer…",
    liveVoteNow: "¡Vota ahora!",
    liveVoted: "Voto guardado ✓ — espera el resultado",
    liveJoinTitle: "Únete al directo",
    liveEnterCode: "Introduce el código del directo",
    liveJoin: "Unirse",
    liveRoomNotFound: "Directo no encontrado, revisa el código",
    liveHostLeft: "El streamer salió del directo",
    liveFinished: "¡Directo terminado!",
    liveCollectiveDestiny: "Destino decidido por el público",
    liveConnecting: "Conectando…",
    statsLives: "{n} directos en curso",
    statsChallenges: "{n} retos aceptados hoy",
    liveBeatDestiny: "¡Supera el destino elegido por {n} personas!",
    liveShareChallengeText: "{n} personas decidieron este destino en directo en Destin Express 🔥 ¿Puedes superarlas?",
    liveConvertHint: "Comparte este enlace al final del directo para retar a tus espectadores 👇",
    liveCopyLink: "Copiar el enlace de reto",
    liveLinkCopied: "Enlace copiado ✓",
    liveVotersDecided: "{n} personas decidieron este destino",
    liveObs: "Modo OBS",
    liveReactions: "Reacciones",
    rareEpic: "⚡ Épico",
    rareLegendary: "🌟 Legendario",
    howToSteps: [
      { t: "1. Elige tu campo", d: "Streamer, futbolista, rapero, gamer o YouTuber." },
      { t: "2. Toma decisiones", d: "10 decisiones rápidas. Tus stats cambian con cada una." },
      { t: "3. Gestiona tus 60 segundos", d: "El reloj corre. Si tu energía llega a 0, se acabó." },
      { t: "4. Descubre tu título", d: "Anónimo, Conocido, Estrella o Leyenda según tu puntuación." },
      { t: "5. Comparte y reta", d: "Genera tu tarjeta, compártela y domina la clasificación." },
    ],
    ranks: { legende: "LEYENDA", star: "ESTRELLA", connu: "CONOCIDO", anonyme: "ANÓNIMO" },
    rankTitles: { legende: "«El Fenómeno»", star: "«La Revelación»", connu: "«El Conocido»", anonyme: "«El Olvidado»" },
    punchlines: {
      legende: "Terminé como LEYENDA en 60 segundos. A ver si lo superas.",
      star: "Estrella en un minuto. Nada mal, ¿eh?",
      connu: "Terminé conocido. Supera mi puntuación si puedes.",
      anonyme: "El destino me olvidó. Ayúdame a vengarme.",
    },
    consentTitle: "Privacidad y publicidad",
    consentText: "Usamos cookies publicitarias (Google AdSense) para mantener el juego gratis. Puedes aceptar o rechazar los anuncios personalizados.",
    consentAccept: "Aceptar",
    consentRefuse: "Rechazar",
    stepPick: "Elige",
    stepDecide: "Decide",
    stepShare: "Comparte",
    store: "Tienda",
    storeSub: "Personaliza tu tarjeta de destino",
    loginGoogle: "Iniciar sesión con Google",
    owned: "Comprado",
    buy: "Comprar",
    loginToBuy: "Inicia sesión para comprar y guardar tus skins",
    logout: "Cerrar sesión",
    cardSkin: "Skin de tarjeta",
    defaultSkin: "Predeterminado",
    paymentSuccess: "¡Compra completada! Skin desbloqueado 🎉",
    paymentPending: "Confirmando el pago…",
    paymentCancel: "Pago cancelado.",
    contact: "Contacto",
    footerLegal: "Privacidad",
    footerNotice: "Aviso legal",
    footerTerms: "Condiciones",
    installTitle: "Instala Destin Express",
    installDesc: "Añade el juego a tu pantalla de inicio para jugar en un toque.",
    installBtn: "Instalar",
    installIos: "En iPhone: toca Compartir y luego «Añadir a inicio»",
    installLater: "Más tarde",
    badgeFree: "100% gratis",
    badgeNoSignup: "Sin registro",
    badgePrivacy: "Datos protegidos",
    badgeLangs: "3 idiomas",
    aboutTitle: "¿Qué es Destin Express?",
    aboutBody:
      "Destin Express es un juego de simulación gratuito y sin registro. En 60 segundos eliges una carrera y tomas decisiones que moldean tu destino, y luego obtienes una tarjeta de puntuación para compartir. Sin descarga obligatoria y sin venta de datos personales: cumplimos el RGPD. El juego funciona directamente en tu navegador, en móvil y ordenador.",
    publishedBy: "Editado por",
    blog: "Blog",
    blogTitle: "El Blog",
    blogSubtitle: "Trucos de juego, detrás de escena y guías para dominar Destin Express.",
    blogRead: "min de lectura",
    blogReadMore: "Leer",
    blogNotFound: "Artículo no encontrado.",
    blogCtaTitle: "¿Listo para probar tu suerte?",
    blogCtaButton: "Jugar ahora",
    langName: "Español",
  },
};

export const LANGS = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];
